// REQ-P1-06b: チャットサイドパネル用キャスティング/契約参照API。

import { api, type paths } from './client';
import type { operations } from './types.gen';
import { ApiStatusError } from './templates';

type HoldRequestUpcomingQuery = NonNullable<
  operations['listUpcomingHoldRequests']['parameters']['query']
>;
type HoldRequestListResponse = NonNullable<
  paths['/admin/hold-requests/upcoming']['get']['responses'][200]['content']
>['application/json'];
type HoldRequestPeriodQuery = NonNullable<
  operations['listPeriodHoldRequests']['parameters']['query']
>;
type ContractListResponse = NonNullable<
  paths['/admin/contracts/upcoming']['get']['responses'][200]['content']
>['application/json'];
type AdminContractBadgeSummaryResponse = NonNullable<
  paths['/admin/contracts/badge-summary']['get']['responses'][200]['content']
>['application/json'];
type ContractUpcomingQuery = NonNullable<
  operations['listUpcomingContracts']['parameters']['query']
>;
type ContractPeriodQuery = NonNullable<
  operations['listPeriodContracts']['parameters']['query']
>;
type AssignedEventQuery = {
  assigned_to_me?: string | boolean;
};
type HoldRequestUpcomingExtendedQuery = HoldRequestUpcomingQuery & AssignedEventQuery;
type HoldRequestPeriodExtendedQuery = HoldRequestPeriodQuery & AssignedEventQuery;
type ContractUpcomingExtendedQuery = ContractUpcomingQuery & AssignedEventQuery;
type ContractPeriodExtendedQuery = ContractPeriodQuery & AssignedEventQuery;

function ensureData<T>(data: T | undefined, status: number, ok: boolean): T {
  if (!ok || !data) throw new ApiStatusError(status);
  return data;
}

export async function listUpcomingHoldRequests(
  query?: HoldRequestUpcomingExtendedQuery
): Promise<HoldRequestListResponse> {
  const { data, response } = await api.GET('/admin/hold-requests/upcoming', {
    params: query ? { query } : undefined,
  });
  return ensureData(data as HoldRequestListResponse | undefined, response.status, response.ok);
}

export async function listPeriodHoldRequests(
  query: HoldRequestPeriodExtendedQuery
): Promise<HoldRequestListResponse> {
  const { data, response } = await api.GET('/admin/hold-requests/period', {
    params: { query },
  });
  return ensureData(data as HoldRequestListResponse | undefined, response.status, response.ok);
}

export async function listUpcomingContracts(
  query?: ContractUpcomingExtendedQuery
): Promise<ContractListResponse> {
  const { data, response } = await api.GET('/admin/contracts/upcoming', {
    params: query ? { query } : undefined,
  });
  return ensureData(data as ContractListResponse | undefined, response.status, response.ok);
}

export async function getAdminContractBadgeSummary(): Promise<AdminContractBadgeSummaryResponse> {
  const { data, response } = await api.GET('/admin/contracts/badge-summary');
  return ensureData(
    data as AdminContractBadgeSummaryResponse | undefined,
    response.status,
    response.ok
  );
}

export async function listPeriodContracts(
  query: ContractPeriodExtendedQuery
): Promise<ContractListResponse> {
  const { data, response } = await api.GET('/admin/contracts/period', {
    params: { query },
  });
  return ensureData(data as ContractListResponse | undefined, response.status, response.ok);
}
